import React from 'react'
import Page from 'src/components/Page'
import LoginEmailSent from './components/LoginEmailSent'
import styles from 'src/features/static/Static.module.sass'
import cx from 'classnames'

const EmailSentPage = () => {
  return (
    <Page className={cx(styles.static, styles.centered)}>
      <LoginEmailSent />
    </Page>
  )
}

export default EmailSentPage
